<template lang="pug">
  div
    | Filter By:
    .ml-2.d-inline-block
      select.form-select.form-select-sm(:value="value" @change="$emit('input', $event.target.value)")
        option(v-for="item in items") {{item}}
</template>

<script>
export default {
  props: ['value', 'items']
}
</script>